import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = {
  children: ReactNode;
};

type State = {
  error: Error | null;
};

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if (import.meta.env.DEV) {
      console.error("Marginalia application error", error, info);
    }
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main className="fatal-error" role="alert">
        <p className="eyebrow">Marginalia hit a problem</p>
        <h1>Your local notes are still in this browser.</h1>
        <p>
          Reload the application. If the problem continues, export your notes
          from another tab before clearing any browser data.
        </p>
        <details>
          <summary>Technical detail</summary>
          <code>{this.state.error.message}</code>
        </details>
        <button type="button" onClick={() => window.location.reload()}>
          Reload Marginalia
        </button>
      </main>
    );
  }
}
